module.exports = __webpack_public_path__ + "static/media/MECHA.3509df42.png";